// extracted by mini-css-extract-plugin
export var body = "ArticleCover-module--body--4a7b0";
export var byline = "ArticleCover-module--byline--ee6b3";
export var container = "ArticleCover-module--container--1999d";
export var heading = "ArticleCover-module--heading--3c59c";
export var image = "ArticleCover-module--image--01c5e";
export var imageContainer = "ArticleCover-module--imageContainer--9b8b9";